import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './styles.scss';

export const FreeBetToggle = (props) => {
    const {
            freeBets,
            selectedFreeBet,
            selectFreeBet,
            clearFreeBet,
            currencySign,
        } = props;
    return (
        <div className="bs-freeBetToggle">
            Use Free Bet: {currencySign}{parseFloat(freeBets[0].amount).toFixed(2)}
            <button
                className={
                    classNames('bs-freeBetToggle__toggle', {
                        'bs-freeBetToggle__toggle--selected': (selectedFreeBet !== null),
                    })
                }
                onClick={() => {
                    if (selectedFreeBet === null) {
                        selectFreeBet(freeBets[0].id);
                    } else {
                        clearFreeBet();
                    }
                }}
            >
            </button>
        </div>
    )
}

FreeBetToggle.defaultProps = {
    selectedFreeBet: null,
}

FreeBetToggle.propTypes = {
    selectedFreeBet: PropTypes.string,
    selectFreeBet: PropTypes.func.isRequired,
    clearFreeBet: PropTypes.func.isRequired,
    currencySign: PropTypes.string.isRequired,
    freeBets: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
        minStake: PropTypes.number,
        maxStake: PropTypes.number,
        amount: PropTypes.number.isRequired,
    })).isRequired,

}

export default FreeBetToggle;



// WEBPACK FOOTER //
// /src/js/common/freeBetToggle/FreeBetToggle.jsx